var render = function render(){
  var _vm$optionUnit$find, _vm$currencyOptions$f, _vm$form$tenderAttach;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('form', {
    staticClass: "bg-white p-4",
    on: {
      "submit": function submit($event) {
        $event.preventDefault();
        return _vm.onSubmit.apply(null, arguments);
      }
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('CustomNav', {
    staticClass: "mb-4",
    attrs: {
      "items": _vm.tabsForm
    },
    on: {
      "item-click": function itemClick(tab) {
        return _vm.activeTab = tab;
      }
    }
  })], 1)], 1), _c('b-row', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.activeTab == 'general',
      expression: "activeTab == 'general'"
    }]
  }, [_c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('div', {
    staticClass: "mb-5 d-flex justify-content-end"
  }, [_vm.localIsDetail && _vm.editId ? _c('b-button', {
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": _vm.toggleEdit
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil-square-o ml-2 text-white"
  }), _vm._v(" Update Data ")]) : !_vm.localIsDetail && _vm.editId && !_vm.is_draft ? _c('b-button', {
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": _vm.toggleEdit
    }
  }, [_c('i', {
    staticClass: "fa fa-floppy-o ml-2 text-white",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Save Update ")]) : _vm._e()], 1)]), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('section', {
    staticClass: "mb-4"
  }, [_c('div', {
    staticClass: "section-title"
  }, [_c('h5', [_vm._v("PROJECT PLAN")])]), _vm.localIsDetail ? [_c('DetailProjectPlan', {
    attrs: {
      "data": _vm.dataDetailShipmentPlan,
      "optionsCompanies": _vm.optionsCompanies,
      "fleetOwnershipOptions": _vm.fleetOwnershipOptions,
      "fleetTypeOptions": _vm.fleetTypeOptions,
      "contractTypeOptions": _vm.contractTypeOptions,
      "termOptions": _vm.termOptions,
      "optionsCargoType": _vm.optionsCargoType,
      "optionUnit": _vm.optionUnit
    }
  })] : _c('b-row', [_c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label-for": "company_id"
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function fn() {
        return [_c('div', [_vm._v(" Subject "), _c('span', {
          staticClass: "text-red"
        }, [_vm._v("*")])])];
      },
      proxy: true
    }])
  }, [_c('b-form-input', {
    staticClass: "w-100",
    attrs: {
      "placeholder": "Subject"
    },
    model: {
      value: _vm.form.subject,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "subject", $$v);
      },
      expression: "form.subject"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label-for": "company_id"
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function fn() {
        return [_c('div', [_vm._v(" Company "), _c('span', {
          staticClass: "text-red"
        }, [_vm._v("*")])])];
      },
      proxy: true
    }])
  }, [_c('b-form-select', {
    attrs: {
      "id": "company_id",
      "options": _vm.optionsCompanies,
      "plain": ""
    },
    model: {
      value: _vm.form.company_id,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "company_id", $$v);
      },
      expression: "form.company_id"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label-for": "priority"
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function fn() {
        return [_c('div', [_vm._v(" Priority "), _c('span', {
          staticClass: "text-red"
        }, [_vm._v("*")])])];
      },
      proxy: true
    }])
  }, [_c('b-form-select', {
    attrs: {
      "id": "priority",
      "options": [{
        value: 1,
        text: 'Low'
      }, {
        value: 2,
        text: 'Medium'
      }, {
        value: 3,
        text: 'High'
      }, {
        value: 5,
        text: 'Normal (Default)'
      }],
      "plain": ""
    },
    model: {
      value: _vm.form.priority,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "priority", $$v);
      },
      expression: "form.priority"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Fleet Ownership"
    }
  }, [_c('b-form-select', {
    attrs: {
      "options": _vm.fleetOwnershipOptions,
      "plain": ""
    },
    model: {
      value: _vm.form.fleet_ownership,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "fleet_ownership", $$v);
      },
      expression: "form.fleet_ownership"
    }
  })], 1)], 1), _c('b-col', {
    staticClass: "pr-0",
    attrs: {
      "md": "2"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Use Third Party"
    }
  }, [_c('b-form-checkbox', {
    attrs: {
      "switch": ""
    },
    model: {
      value: _vm.form.third_party,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "third_party", $$v);
      },
      expression: "form.third_party"
    }
  }, [_vm._v(" " + _vm._s(_vm.form.third_party ? 'Yes' : 'No') + " ")])], 1)], 1), _c('b-col', {
    staticClass: "d-flex align-items-end pb-4 pl-0",
    attrs: {
      "md": "4"
    }
  }, [_c('b-form-group', {
    staticClass: "w-100",
    attrs: {
      "label": "Third Party Company"
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function fn() {
        return [_c('div', [_vm._v(" Third Party Company "), _c('span', {
          staticClass: "text-red"
        }, [_vm._v("*")])])];
      },
      proxy: true
    }])
  }, [_c('b-form-input', {
    staticClass: "w-100",
    attrs: {
      "placeholder": "Third Party Company",
      "disabled": !_vm.form.third_party
    },
    model: {
      value: _vm.form.third_party_company,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "third_party_company", $$v);
      },
      expression: "form.third_party_company"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Fleet Type"
    }
  }, [_c('div', {
    staticClass: "d-flex align-items-center"
  }, [_c('v-multiselect', {
    attrs: {
      "options": _vm.fleetTypeOptions,
      "multiple": true,
      "placeholder": "Select Fleet Type",
      "track-by": "value",
      "label": "text"
    },
    on: {
      "input": _vm.onFleetTypeChange
    },
    model: {
      value: _vm.form.fleet_type_ids,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "fleet_type_ids", $$v);
      },
      expression: "form.fleet_type_ids"
    }
  }, [_c('span', {
    attrs: {
      "slot": "noResult"
    },
    slot: "noResult"
  }, [_vm._v(" Oops! No elements found. Consider changing the search query. ")])]), _vm.form.fleet_type_ids && _vm.form.fleet_type_ids.length > 0 ? _c('b-button', {
    staticClass: "ml-2",
    attrs: {
      "variant": "outline-secondary",
      "size": "sm",
      "title": "Clear All"
    },
    on: {
      "click": _vm.clearAllFleetTypes
    }
  }, [_c('i', {
    staticClass: "fa fa-times"
  })]) : _vm._e()], 1)])], 1), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Period"
    }
  }, [_c('date-picker', {
    staticClass: "w-100",
    attrs: {
      "placeholder": "Select Period",
      "value-type": "YYYY-MM-DD",
      "range": ""
    },
    model: {
      value: _vm.form.period,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "period", $$v);
      },
      expression: "form.period"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Contract Type *"
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function fn() {
        return [_c('div', [_vm._v(" Contract Type "), _c('span', {
          staticClass: "text-red"
        }, [_vm._v("*")])])];
      },
      proxy: true
    }])
  }, [_c('b-form-select', {
    attrs: {
      "options": _vm.contractTypeOptions,
      "plain": ""
    },
    model: {
      value: _vm.form.contract_type_id,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "contract_type_id", $$v);
      },
      expression: "form.contract_type_id"
    }
  })], 1), _vm.form.contract_type_id && _vm.selectedContractType && !_vm.isDetail ? [_c('div', {
    staticClass: "alert alert-primary d-flex align-items-center p-1 px-2",
    attrs: {
      "role": "alert"
    }
  }, [_c('i', {
    staticClass: "fa fa-exclamation-circle mr-2"
  }), _vm.selectedContractType.is_spal === 1 ? _c('small', {
    staticClass: "font-semibold"
  }, [_vm._v(" This type using SPAL ")]) : _c('small', {
    staticClass: "font-semibold"
  }, [_vm._v(" This type not using SPAL ")])])] : _vm._e()], 2), _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "PFA"
    }
  }, [_c('b-form-checkbox', {
    attrs: {
      "switch": ""
    },
    model: {
      value: _vm.form.is_pfa,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "is_pfa", $$v);
      },
      expression: "form.is_pfa"
    }
  }, [_vm._v(" " + _vm._s(_vm.form.is_pfa ? 'Yes' : 'No') + " ")])], 1)], 1), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Cargo Type"
    }
  }, [_c('b-form-select', {
    attrs: {
      "options": _vm.optionsCargoType,
      "plain": ""
    },
    on: {
      "change": _vm.onChangeCargoType
    },
    model: {
      value: _vm.form.cargo_type_id,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "cargo_type_id", $$v);
      },
      expression: "form.cargo_type_id"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Total Quantity"
    }
  }, [_c('b-input-group', [_c('b-form-input', {
    attrs: {
      "type": "number",
      "disabled": "",
      "value": _vm.totalQuantityAdd
    }
  }), _c('b-input-group-append', [_c('b-dropdown', {
    attrs: {
      "right": "",
      "variant": "outline-secondary",
      "text": (_vm$optionUnit$find = _vm.optionUnit.find(function (el) {
        return el.value === _vm.form.unit;
      })) === null || _vm$optionUnit$find === void 0 ? void 0 : _vm$optionUnit$find.text,
      "toggle-class": "text-dark",
      "size": "sm"
    }
  }, _vm._l(_vm.optionUnit, function (unit, index) {
    return _c('b-dropdown-item', {
      key: index,
      on: {
        "click": function click($event) {
          _vm.form.unit = unit === null || unit === void 0 ? void 0 : unit.value;
        }
      }
    }, [_vm._v(" " + _vm._s(unit === null || unit === void 0 ? void 0 : unit.text) + " ")]);
  }), 1)], 1)], 1)], 1)], 1), _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Term"
    }
  }, [_c('b-form-select', {
    attrs: {
      "options": _vm.termOptions,
      "plain": ""
    },
    on: {
      "change": _vm.onTermChange
    },
    model: {
      value: _vm.form.term,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "term", $$v);
      },
      expression: "form.term"
    }
  })], 1)], 1), _c('b-col', {
    staticClass: "d-flex align-items-end pb-3 pl-0",
    attrs: {
      "md": "4"
    }
  }, [_c('b-form-group', {
    staticClass: "w-100",
    attrs: {
      "label": "Term Description"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: _vm.form.termDescription,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "termDescription", $$v);
      },
      expression: "form.termDescription"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Laycan"
    }
  }, [_c('date-picker', {
    staticClass: "w-100",
    attrs: {
      "placeholder": "Select Laycan",
      "value-type": "YYYY-MM-DD",
      "range": ""
    },
    model: {
      value: _vm.form.laycan,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "laycan", $$v);
      },
      expression: "form.laycan"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Distance (NM)"
    }
  }, [_c('InputCurrency', {
    attrs: {
      "type": "number",
      "prepend": "",
      "append": "NM"
    },
    model: {
      value: _vm.form.distance,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "distance", $$v);
      },
      expression: "form.distance"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Currency"
    }
  }, [_c('b-form-select', {
    attrs: {
      "options": _vm.currencyOptions,
      "plain": ""
    },
    on: {
      "change": _vm.onCurrencyChange
    },
    model: {
      value: _vm.form.currency_id,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "currency_id", $$v);
      },
      expression: "form.currency_id"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Currency Rate"
    }
  }, [_c('InputCurrency', {
    attrs: {
      "prepend": "",
      "disabled": ""
    },
    model: {
      value: _vm.form.currencyRate,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "currencyRate", $$v);
      },
      expression: "form.currencyRate"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Est. Freight Rate"
    }
  }, [_c('InputCurrency', {
    attrs: {
      "prepend": (_vm$currencyOptions$f = _vm.currencyOptions.find(function (el) {
        return el.value == _vm.form.currency_id;
      })) === null || _vm$currencyOptions$f === void 0 ? void 0 : _vm$currencyOptions$f.text
    },
    model: {
      value: _vm.form.freightRate,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "freightRate", $$v);
      },
      expression: "form.freightRate"
    }
  })], 1)], 1), _c('b-col', {
    staticClass: "pb-4 d-flex align-items-end px-0",
    attrs: {
      "md": "2"
    }
  }, [_c('div', {
    staticClass: "d-flex align-items-center"
  }, [_c('b-form-checkbox', {
    attrs: {
      "id": "ppn"
    },
    model: {
      value: _vm.form.isPpn,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "isPpn", $$v);
      },
      expression: "form.isPpn"
    }
  }), _c('label', {
    staticClass: "mb-0 text-nowrap",
    attrs: {
      "for": "ppn"
    }
  }, [_vm._v("Include PPN")])], 1)]), _c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Remarks"
    }
  }, [_c('b-form-textarea', {
    attrs: {
      "plain": ""
    },
    model: {
      value: _vm.form.remarks,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "remarks", $$v);
      },
      expression: "form.remarks"
    }
  })], 1)], 1)], 1)], 2), _c('section', {
    staticClass: "mb-5"
  }, [_c('div', {
    staticClass: "section-title"
  }, [_c('h5', [_vm._v("APPROVAL")])]), _vm.hasLoadApprovalOrBusdevTeams ? _c('ApprovalProject', {
    attrs: {
      "approvalOptions": _vm.approvalOptions,
      "approvals": _vm.approvals,
      "isDetail": _vm.localIsDetail,
      "profileId": _vm.userProfileId
    },
    on: {
      "update:approvals": _vm.onApprovalsChange
    }
  }) : _vm._e()], 1), _c('section', {
    staticClass: "mb-5"
  }, [_c('div', {
    staticClass: "section-title d-flex align-items-center justify-content-between"
  }, [_c('h5', [_vm._v("BUSDEV TEAM")])]), _vm.hasLoadApprovalOrBusdevTeams ? _c('ApprovalProject', {
    attrs: {
      "approvalOptions": _vm.approvalOptions,
      "approvals": _vm.busdevTeam,
      "isDetail": _vm.localIsDetail
    },
    on: {
      "update:approvals": function updateApprovals(val) {
        return _vm.busdevTeam = val;
      }
    }
  }) : _vm._e()], 1)]), _c('b-col', {
    staticClass: "pl-4",
    attrs: {
      "md": "6"
    }
  }, [_c('CustomerInfoSection', {
    staticClass: "mb-5",
    attrs: {
      "customerOptions": _vm.customerOptions,
      "isDetail": _vm.localIsDetail
    },
    on: {
      "refecthCustomerList": _vm.fetchCustomerProspects
    },
    model: {
      value: _vm.form.customerInfo,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "customerInfo", $$v);
      },
      expression: "form.customerInfo"
    }
  }), _c('div', {
    staticClass: "mb-5"
  }, [_c('div', {
    staticClass: "section-title"
  }, [_c('h5', [_vm._v("PORT")])]), _c('TablePortProject', {
    staticClass: "mt-3",
    attrs: {
      "form": _vm.form,
      "polOptions": _vm.positionListTextPOL,
      "podOptions": _vm.positionListTextPOD,
      "isDetail": _vm.localIsDetail
    }
  })], 1), _c('section', {
    staticClass: "mb-5"
  }, [_c('div', {
    staticClass: "section-title"
  }, [_c('h5', [_vm._v("TENDER")])]), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "PIC"
    }
  }, [!_vm.localIsDetail ? [_c('b-form-input', {
    attrs: {
      "plain": ""
    },
    model: {
      value: _vm.form.tenderPic,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "tenderPic", $$v);
      },
      expression: "form.tenderPic"
    }
  })] : [_c('p', {
    staticClass: "form-control-plaintext font-semibold"
  }, [_vm._v(" " + _vm._s(_vm.form.tenderPic || '-') + " ")])]], 2)], 1), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Url"
    }
  }, [!_vm.localIsDetail ? [_c('b-form-input', {
    attrs: {
      "plain": ""
    },
    model: {
      value: _vm.form.tenderUrl,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "tenderUrl", $$v);
      },
      expression: "form.tenderUrl"
    }
  })] : [_c('p', {
    staticClass: "form-control-plaintext font-semibold"
  }, [_vm._v(" " + _vm._s(_vm.form.tenderUrl || '-') + " ")])]], 2)], 1), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Attachment"
    }
  }, [!_vm.localIsDetail ? [_c('b-form-file', {
    attrs: {
      "multiple": ""
    },
    model: {
      value: _vm.form.tenderAttachment,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "tenderAttachment", $$v);
      },
      expression: "form.tenderAttachment"
    }
  })] : [((_vm$form$tenderAttach = _vm.form.tenderAttachment) === null || _vm$form$tenderAttach === void 0 ? void 0 : _vm$form$tenderAttach.length) > 0 ? _c('div', _vm._l(_vm.form.tenderAttachment, function (file, index) {
    var _file$url, _file$url2;
    return _c('button', {
      key: index,
      staticClass: "btn btn-link p-0 form-control-plaintext text-left",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function click($event) {
          return _vm.openTenderFile(file);
        }
      }
    }, [_vm._v(" " + _vm._s((_file$url = file.url) === null || _file$url === void 0 ? void 0 : _file$url.split('/')[((_file$url2 = file.url) === null || _file$url2 === void 0 ? void 0 : _file$url2.split('/').length) - 1]) + " ")]);
  }), 0) : _vm._e()]], 2)], 1), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Description"
    }
  }, [!_vm.localIsDetail ? [_c('b-form-textarea', {
    attrs: {
      "plain": ""
    },
    model: {
      value: _vm.form.tenderDescription,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "tenderDescription", $$v);
      },
      expression: "form.tenderDescription"
    }
  })] : [_c('p', {
    staticClass: "form-control-plaintext font-semibold"
  }, [_vm._v(" " + _vm._s(_vm.form.tenderDescription || '-') + " ")])]], 2)], 1)], 1)], 1)], 1)], 1), _c('b-row', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.activeTab == 'spal',
      expression: "activeTab == 'spal'"
    }]
  }, [_c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_vm.activeTab == 'spal' ? _c('SpalSection', {
    attrs: {
      "data": _vm.form.spal_process,
      "project": _vm.spalProjectInfo,
      "customer": _vm.spalCustomerInfo,
      "isDetail": _vm.localIsDetail,
      "editId": _vm.editId,
      "required": true
    },
    model: {
      value: _vm.spalModel,
      callback: function callback($$v) {
        _vm.spalModel = $$v;
      },
      expression: "spalModel"
    }
  }) : _vm._e()], 1)], 1), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.activeTab == 'shipment-plan',
      expression: "activeTab == 'shipment-plan'"
    }]
  }, [_c('DetailShipmentPlan', {
    attrs: {
      "generateShipmentPlanNumber": _vm.generateShipmentPlanNumber,
      "form": _vm.form,
      "optionsFleetTypes": _vm.fleetTypeOptions,
      "optionsCargoType": _vm.optionsCargoType,
      "optionsTerm": _vm.termOptions,
      "optionsProjectTerms": _vm.optionsProjectTerms,
      "positionListTextPOD": _vm.positionListTextPOD,
      "positionListTextPOL": _vm.positionListTextPOL,
      "fleetOptions": _vm.fleetOptions,
      "isDetail": _vm.localIsDetail
    },
    on: {
      "cancel-update": _vm.toggleEdit,
      "submit": _vm.onSubmit
    }
  })], 1), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.activeTab == 'document',
      expression: "activeTab == 'document'"
    }]
  }, [_c('formProjectDocument', {
    attrs: {
      "form": _vm.form,
      "isDetail": _vm.localIsDetail,
      "shipmentNumberOptions": _vm.shipmentNumberOptions
    },
    on: {
      "submit": _vm.onSubmit
    }
  })], 1), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.activeTab == 'pfa',
      expression: "activeTab == 'pfa'"
    }]
  }, [_vm.activeTab === 'pfa' ? _c('SlideFormPFA', {
    attrs: {
      "pfa-action": 'EDIT',
      "pfa-id": _vm.editId,
      "data-project": _vm.dataProject,
      "options-fleets": _vm.optionsFleets,
      "optionsCargoType": _vm.optionsCargoType,
      "fleetTypeOptions": _vm.fleetTypeOptions,
      "is-reset": false
    }
  }) : _vm._e()], 1), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.activeTab == 'trip_document',
      expression: "activeTab == 'trip_document'"
    }]
  }, [_vm.activeTab == 'trip_document' ? _c('TripDocumentTable', {
    attrs: {
      "data-project": _vm.form
    },
    on: {
      "refresh": _vm.loadDetailFromTable
    },
    model: {
      value: _vm.formState.tripDocuments,
      callback: function callback($$v) {
        _vm.$set(_vm.formState, "tripDocuments", $$v);
      },
      expression: "formState.tripDocuments"
    }
  }) : _vm._e()], 1), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.activeTab == 'payment_list',
      expression: "activeTab == 'payment_list'"
    }]
  }, [_c('PaymentListTable', {
    attrs: {
      "projectId": _vm.editId,
      "projectData": _vm.projectDataForSidebar,
      "optionsProjectTerms": _vm.optionsProjectTerms,
      "positionListTextPOD": _vm.positionListTextPOD,
      "positionListTextPOL": _vm.positionListTextPOL,
      "optionsFleetTypes": _vm.fleetTypeOptions,
      "optionsCargoType": _vm.optionsCargoType,
      "fleetOptions": _vm.fleetOptions,
      "refreshData": _vm.fetchPaymentLists
    },
    model: {
      value: _vm.formState.paymentList,
      callback: function callback($$v) {
        _vm.$set(_vm.formState, "paymentList", $$v);
      },
      expression: "formState.paymentList"
    }
  })], 1), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.activeTab == 'real_shipment',
      expression: "activeTab == 'real_shipment'"
    }]
  }, [_vm.activeTab == 'real_shipment' ? _c('TabRealShipmentNew', {
    attrs: {
      "projectData": _vm.form,
      "optionsFleets": _vm.optionsFleets
    }
  }) : _vm._e()], 1), !_vm.localIsDetail ? _c('div', {
    staticClass: "w-100 d-flex mt-4"
  }, [_c('b-button', {
    staticClass: "mr-2 w-50",
    attrs: {
      "variant": "outline-primary"
    },
    on: {
      "click": function click($event) {
        return _vm.$emit('close');
      }
    }
  }, [_vm._v(" Cancel ")]), _vm.is_draft ? _c('b-button', {
    staticClass: "w-50 mr-2",
    attrs: {
      "type": "button",
      "variant": "primary",
      "disabled": _vm.saving
    },
    on: {
      "click": function click($event) {
        return _vm.onSubmit(false, true);
      }
    }
  }, [_vm._v(" Save as Draft ")]) : _vm._e(), _c('b-button', {
    staticClass: "w-50",
    attrs: {
      "type": "submit",
      "variant": "primary",
      "disabled": _vm.saving
    }
  }, [_vm._v(" Submit ")])], 1) : _vm._e()], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }